import { useTranslation } from "react-i18next";
import { useUser, useClerk } from "@clerk/clerk-react";
import { useNavigate } from "react-router-dom";
import styles from "./Navigation.module.css";

const UserProfile: React.FC = () => {
  const { t } = useTranslation();
  const { user } = useUser();
  const { signOut } = useClerk();
  const navigate = useNavigate();

  const handleSignOut = async () => {
    await signOut();
    navigate("/sign-in");
  };

  const displayName =
    user?.firstName || user?.emailAddresses[0]?.emailAddress || "User";

  return (
    <div className={styles.userDropdown}>
      <button className={styles.userButton} type="button">
        {displayName}
        <svg width="12" height="12" viewBox="0 0 12 12" fill="currentColor">
          <path d="M3 5l3 3 3-3" stroke="currentColor" strokeWidth="1.5" fill="none" strokeLinecap="round" />
        </svg>
      </button>
      <div className={styles.dropdownMenu}>
        <button className={styles.dropdownItem} onClick={handleSignOut}>
          {t("common.signOut")}
        </button>
      </div>
    </div>
  );
};

export default UserProfile;
